import { mapDTO } from '@twistezo/ts-dto-mapper'
import { isNil } from 'lodash'

import { JSON_SPACE } from 'constants/json'
import { millisecondsToMinutes } from 'utils/number'
import { RichPlacementMultiAnchor } from '../types'
import { RichPlacementMultiAnchorDTO } from './types'

type From = RichPlacementMultiAnchorDTO
type To = RichPlacementMultiAnchor

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      counterStyle,
      customStyling,
      desktopAdDisplaysBeforeRefresh,
      desktopSingleAdViewTime,
      displayAfterUserInteractionEnabled,
      frequencyCappingEnabled,
      fullWidthModeEnabled,
      impressionLimit,
      mobileAdDisplaysBeforeRefresh,
      mobileSingleAdViewTime,
      showCloseButtonEnabled,
      timeWindow,
    }: From): To => ({
      counterStyle,
      customStyling: JSON.stringify(customStyling, null, JSON_SPACE),
      desktopAdDisplaysBeforeRefresh,
      desktopSingleAdViewTime,
      displayAfterUserInteraction: displayAfterUserInteractionEnabled,
      frequencyCappingEnabled: frequencyCappingEnabled ?? undefined,
      fullWidthMode: fullWidthModeEnabled,
      impressionLimit: impressionLimit ?? undefined,
      mobileAdDisplaysBeforeRefresh,
      mobileSingleAdViewTime,
      showCloseButton: showCloseButtonEnabled,
      timeWindow: isNil(timeWindow) ? undefined : millisecondsToMinutes(timeWindow),
    }),
  )
